<template>
  <div
    :class="{
      'slider-fi': true,
      'slider-fi--clipped-right': clippedRight,
    }"
  >
    <div
      v-if="!isMounted"
      class="slider-fi__ssr-slide"
      :style="`width: ${Math.max(100, numberedSlots.length * 40)}%;`"
    >
      <div
        v-for="slotNr in numberedSlots"
        :key="slotNr"
        class="slider-fi__slide"
      >
        <slot :name="slotNr" />
      </div>
    </div>

    <Splide
      v-else
      ref="splide"
      :options="{
        drag: 'free',
        snap: true,
        arrows: false,
        type: numberedSlots.length > 2 ? 'loop' : 'slide',
        autoWidth: true,
      }"
      @splide:move="sliderMove"
      @splide:moved="sliderMoved"
      @splide:drag="sliderMove"
      @splide:dragged="sliderMoved"
    >
      <splide-slide
        v-for="slotNr in numberedSlots"
        :key="slotNr"
        class="slider-fi__slide"
      >
        <slot :name="slotNr" />
      </splide-slide>
    </Splide>
  </div>
</template>

<script setup lang="ts">
import '@splidejs/vue-splide/css/core';

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { type ComponentPublicInstance, computed, onMounted, ref, useSlots } from 'vue';

const slots = useSlots();
const splide = ref<ComponentPublicInstance<typeof Splide> | null>(null);
const emits = defineEmits<{
  'before-change': [value: void];
  'after-change': [value: void];
}>();

defineProps<{
  clippedRight?: boolean;
}>();

const isMounted = ref<boolean>(false);
onMounted(() => {
  isMounted.value = true;
});

const numberedSlots = computed<Array<number>>(() => {
  const allSlotNames = Object.keys(slots);
  return allSlotNames
    .map((string) => Number.parseInt(string))
    .filter((number) => number || number === 0)
    .sort();
});

const prev = () => {
  splide.value?.go('<');
};

const next = () => {
  splide.value?.go('>');
};
const pause = () => {
  splide.value?.pause();
};
const play = () => {
  splide.value?.play();
};

const sliderMove = () => {
  emits('before-change');
};

const sliderMoved = () => {
  emits('after-change');
};

defineExpose({
  prev,
  next,
  pause,
  play,
});
</script>

<style scoped src="./slider-fi" />
